import { Injectable } from '@angular/core';
import { HttpService } from '../';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayGateDoPayService {

  constructor(private http: HttpService) { }

  getPaymentRequestData(teanxId: string) {
    return this.http.flightgetall(`apiV2/payment/manual-pay?id=${teanxId}`).pipe(
      map(res => {
        const d = res?.data;
        return { ...d };
      }),
      catchError((err) => {
        console.log(err?.error);
        return of({ 
          isError: true, 
          errorMessage: err?.error || 'Something went wrong. Please try again later.' 
        });
      })
    );
  }
}
